import { Component, OnInit } from '@angular/core';
import {RestService} from "../../shared/rest/rest.service";
import {ToolbarService, TranslateService} from "bos-commons";
import {TitleComponent} from "../title-component";
import {SessionConfiguration} from "./session-configuration";
import {AlertService} from "../../shared/alert.service";

@Component({
  selector: 'app-admin-session-config',
  templateUrl: './admin-session-config.component.html',
  styleUrls: ['./admin-session-config.component.scss', '../html-page/html-page.component.scss']
})
export class AdminSessionConfigComponent extends  TitleComponent implements OnInit {

  sessionConfig: SessionConfiguration;

  initialized = false;

  inProgress: any;
  success: any;

  getTitleKey() {
    return  'admin.sessions.config';
  }

  constructor(private restService: RestService,
              private translate: TranslateService,
              toolbarService: ToolbarService,
              private alertService: AlertService,) {
    super(toolbarService, translate);
  }



  ngOnInit(): void {
    super.ngOnInit();
    this.initialize();
  }

  private initialize() {
    this.restService.getSessionConfig().subscribe(sc => {
      this.sessionConfig = sc;
      this.initialized = true;
    })
  }

  isFilled() {
    return this.sessionConfig.sessionTimeout > 0
  }

  save() {

    this.restService.updateSessionConfig(this.sessionConfig).subscribe(() => {
      this.success = true;
      this.inProgress = false;

      this.alertService.success("SessionConfig.save.success")

    }, () => {
      this.success = false;
      this.inProgress = false;
      this.alertService.error("SessionConfig.save.error")
    })
  }
}
